import React from "react";
import ReactDOM from "react-dom/client";
import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MantineColorsTuple, MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import "dayjs/locale/en";

const brand: MantineColorsTuple = [
  "#ecfce5", // 0
  "#dcfae3", // 1
  "#b0f3bd", // 2
  "#81eb96", // 3
  "#5ce475", // 4
  "#44e060", // 5
  "#33c951", // 6 (Primary-ish)
  "#26a642", // 7
  "#19752e", // 8 (Our Mobile Green)
  "#145223", // 9
];

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <MantineProvider
      defaultColorScheme="dark"
      theme={{
        primaryColor: "brand",
        colors: { brand },
      }}
    >
      <DatesProvider settings={{ locale: "en" }}>
        <App />
      </DatesProvider>
    </MantineProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
